import { render, staticRenderFns } from "./StatDimensionConfigForm.vue?vue&type=template&id=2bf685a7&scoped=true&"
import script from "./StatDimensionConfigForm.vue?vue&type=script&lang=js&"
export * from "./StatDimensionConfigForm.vue?vue&type=script&lang=js&"
import style0 from "./StatDimensionConfigForm.vue?vue&type=style&index=0&id=2bf685a7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf685a7",
  null
  
)

export default component.exports